import { ICellEditorParams } from "@ag-grid-community/core";
import {
  Button,
  Center,
  Circle,
  HStack,
  Tooltip,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import React from "react";
import {
  IRegistryDataColumn,
  RegistryDataColumnTypeEnum,
} from "../../../models/RegistryDataColumn";
import { MaterialIcon } from "../../shared/MaterialIcon";
import { ManageFileModal } from "../ManageFileModal";

export interface IStagedFile {
  filename?: string;
  fileLocation?: string;
}

export const EditorFile = React.forwardRef((props: ICellEditorParams, ref) => {
  const inputRef = React.useRef<any>();

  const toast = useToast();

  const [value, setValue] = React.useState<IStagedFile>();

  const {
    isOpen: isOpenIndividualModal,
    onOpen: onOpenIndividualModal,
    onClose: onCloseIndividualModal,
  } = useDisclosure();

  const colDef = props.colDef as any;
  const colMeta = colDef.meta as IRegistryDataColumn;

  const isRequired = colMeta.is_required;

  const isValidInput = React.useCallback((): boolean => {
    let isValidCheck = true;

    if (isRequired && !value) {
      isValidCheck = false;
    }

    if (colMeta.validation != null) {
      if (colMeta.type == RegistryDataColumnTypeEnum.file) {
        // do something here to check file size, extension
        isValidCheck = true;
      } else {
        isValidCheck = true;
      }
    }
    return isValidCheck;
  }, [isRequired, value]);

  const handleOnCloseModal = () => {
    onCloseIndividualModal();
  };

  const handleOnFileChange = (filename: string, tempFileKey?: string) => {
    setValue({
      filename: filename,
      fileLocation: tempFileKey,
    });
    onCloseIndividualModal();
  };

  React.useImperativeHandle(ref, () => {
    return {
      getValue: () => {
        // Return the stage file edit value
        let valueOut = value;

        // Dont return the stage file edit if its the same as the value in though
        if (
          props.value &&
          props.value.hasOwnProperty("filename") &&
          props.value.filename === value?.filename
        ) {
          valueOut = props.value;
        } else if (props.value === value?.filename) {
          valueOut = props.value;
        }

        return valueOut;
      },
      isCancelAfterEnd: () => {
        const isValid = isValidInput();

        if (!isValid) {
          toast({
            title: "Required field",
            description: `Changes were reverted due to invalid input.`,
            status: "warning",
            duration: 4000,
            isClosable: true,
          });
        }

        return !isValid;
      },
    };
  });

  React.useEffect(() => {
    let valueUpdate: IStagedFile = props.value;

    // Put the incoming value on the stage file dict
    if (props.value && !props.value.hasOwnProperty("filename")) {
      valueUpdate = {
        filename: props.value,
      };
    }

    setValue(valueUpdate);
  }, [props]);

  // React.useEffect(() => {
  //   const isValidUpdate = isValidInput();
  //   setIsValid(isValidUpdate);
  // }, [value, isValidInput]);

  return (
    <>
      <Center h="full">
        <HStack spacing={4}>
          {value?.filename && (
            <Tooltip label={value?.filename}>
              <Circle borderWidth="1px" borderColor="border" bg="bg.high" p={1}>
                <MaterialIcon
                  color={"text.primary"}
                  name={"task"}
                  fontSize="md"
                  variant="outline"
                />
              </Circle>
            </Tooltip>
          )}
          <Button ref={inputRef} size="sm" onClick={onOpenIndividualModal}>
            Change File
          </Button>
        </HStack>
      </Center>
      <ManageFileModal
        title={`Upload ${colMeta?.display}`}
        fileHelperText={".jpg, .gif, or .png. Max file size 5 MB."}
        isOpen={isOpenIndividualModal}
        onClose={handleOnCloseModal}
        onFileChange={handleOnFileChange}
        currentFileName={value?.filename}
      />
    </>
  );
});
